<template>
  <v-dialog
    v-model="isVisible"
    :fullscreen="isFullScreen"
    height="64"
    max-height="64"
    max-width="850"
    persistent
    scrollable
  >
    <v-card v-if="editItem">
      <v-toolbar
        flat
      >
        <v-avatar
          class="mr-3"
          color="blue"
        >
          <v-icon color="blue lighten-5">
            {{ editItem?.Id ? $t('Marketing.Email.Dialog.EditCampaign.Toolbar.Icon') : $t('Marketing.Email.Dialog.AddCampaign.Toolbar.Icon') }}
          </v-icon>
        </v-avatar>


        <v-toolbar-title
          class="pl-1"
        >
          <div class="body-3">
            {{ editItem?.Id ? $t('Marketing.Email.Dialog.EditCampaign.Toolbar.Title') : $t('Marketing.Email.Dialog.AddCampaign.Toolbar.Title') }}
          </div>
          <div class="text-caption">
            {{ editItem?.Id ? $t('Marketing.Email.Dialog.EditCampaign.Toolbar.SubTitle') : $t('Marketing.Email.Dialog.AddCampaign.Toolbar.SubTitle') }}
          </div>
        </v-toolbar-title>

        <v-spacer />

        <v-btn
          class="ml-0"
          icon
          @click="onCancelButtonClick"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider />

      <v-card-text class="pa-2 fill-height">
        <v-form
          ref="dataForm"
          v-model="dataFormValid"
          @submit.prevent
        >
          <v-container
            class="pa-1"
            fluid
          >
            <v-row
              class="px-2"
              dense
            >
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="editItem.Name"
                  :hint="$t('Marketing.Email.Dialog.EditCampaign.Field.Name.Hint')"
                  :label="$t('Marketing.Email.Dialog.EditCampaign.Field.Name.Label')"
                  :prepend-icon="$t('Marketing.Email.Dialog.EditCampaign.Field.Name.Icon')"
                  :rules="formFieldRules.Name"
                  filled
                  hide-details="auto"
                />
              </v-col>

              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="editItem.Tag"
                  :hint="$t('Marketing.Email.Dialog.EditCampaign.Field.Tag.Hint')"
                  :items="tagItems"
                  :label="$t('Marketing.Email.Dialog.EditCampaign.Field.Tag.Label')"
                  :prepend-icon="$t('Marketing.Email.Dialog.EditCampaign.Field.Tag.Icon')"
                  :rules="formFieldRules.Tag"
                  chips
                  class=""
                  clearable
                  dense
                  filled
                  height="56"
                  hide-details="auto"
                  item-text="Name"
                  item-value="Id"
                  multiple
                  persistent-hint
                  required
                >
                  <template #selection="data">
                    <v-chip
                      :key="data.item.Id"
                      class="chip--select-multi"
                      color="indigo"
                      label
                      small
                      text-color="white"
                      @input="data.parent.selectItem(data.item)"
                    >
                      {{ data.item.Name }}
                    </v-chip>
                  </template>

                  <template
                    v-if="userCanManage"
                    #append-outer
                  >
                    <v-btn
                      color="primary"
                      icon
                      @click="showAddTagDialog"
                    >
                      <v-icon>
                        mdi-plus-circle
                      </v-icon>
                    </v-btn>
                  </template>
                </v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>{{ $t('Marketing.Email.Dialog.EditCampaign.Section.Audience') }}</v-card-title>
                  <v-card-text>
                    <v-container
                      class="pa-0"
                      fluid
                    >
                      <v-row dense>
                        <v-row dense>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-select
                              v-model="editItem.GroupIncludes"
                              :hint="$t('Marketing.Email.Dialog.EditCampaign.Field.GroupIncludes.Hint')"
                              :items="groups"
                              :label="$t('Marketing.Email.Dialog.EditCampaign.Field.GroupIncludes.Label')"
                              :prepend-icon="$t('Marketing.Email.Dialog.EditCampaign.Field.GroupIncludes.Icon')"
                              :rules="formFieldRules.GroupIncludes"
                              chips
                              class=""
                              clearable
                              dense
                              filled
                              height="56"
                              hide-details="auto"
                              item-text="Name"
                              item-value="Id"
                              multiple
                              persistent-hint
                              required
                            >
                              <template #selection="data">
                                <v-chip
                                  :key="data.item.Id"
                                  class="chip--select-multi"
                                  color="green"
                                  label
                                  small
                                  text-color="white"
                                  @input="data.parent.selectItem(data.item)"
                                >
                                  {{ data.item.Name }}
                                </v-chip>
                              </template>
                            </v-select>
                          </v-col>

                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-select
                              v-model="editItem.GroupExcludes"
                              :hint="$t('Marketing.Email.Dialog.EditCampaign.Field.GroupExcludes.Hint')"
                              :items="groups"
                              :label="$t('Marketing.Email.Dialog.EditCampaign.Field.GroupExcludes.Label')"
                              :prepend-icon="$t('Marketing.Email.Dialog.EditCampaign.Field.GroupExcludes.Icon')"
                              :rules="formFieldRules.GroupExcludes"
                              chips
                              class=""
                              clearable
                              dense
                              filled
                              height="56"
                              hide-details="auto"
                              item-text="Name"
                              item-value="Id"
                              multiple
                              persistent-hint
                              required
                            >
                              <template #selection="data">
                                <v-chip
                                  :key="data.item.Id"
                                  class="chip--select-multi"
                                  color="red"
                                  label
                                  small
                                  text-color="white"
                                  @input="data.parent.selectItem(data.item)"
                                >
                                  {{ data.item.Name }}
                                </v-chip>
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>{{ $t('Marketing.Email.Dialog.EditCampaign.Section.Sender') }}</v-card-title>
                  <v-card-text>
                    <v-container
                      class="pa-0"
                      fluid
                    >
                      <v-row dense>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-text-field
                            v-model="editItem.SenderName"
                            :hint="$t('Marketing.Email.Dialog.EditCampaign.Field.SenderName.Hint')"
                            :label="$t('Marketing.Email.Dialog.EditCampaign.Field.SenderName.Label')"
                            :prepend-icon="$t('Marketing.Email.Dialog.EditCampaign.Field.SenderName.Icon')"
                            :rules="formFieldRules.SenderName"
                            disabled
                            filled
                            hide-details="auto"
                          />
                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-text-field
                            v-model="editItem.SenderEmail"
                            :hint="$t('Marketing.Email.Dialog.EditCampaign.Field.SenderEmail.Hint')"
                            :label="$t('Marketing.Email.Dialog.EditCampaign.Field.SenderEmail.Label')"
                            :prepend-icon="$t('Marketing.Email.Dialog.EditCampaign.Field.SenderEmail.Icon')"
                            :rules="formFieldRules.SenderEmail"
                            disabled
                            filled
                            hide-details="auto"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>{{ $t('Marketing.Email.Dialog.EditCampaign.Section.Message') }}</v-card-title>
                  <v-card-text>
                    <v-container
                      class="pa-0"
                      fluid
                    >
                      <v-row dense>
                        <v-col cols="12">
                          <v-text-field
                            v-model="editItem.Subject"
                            :hint="$t('Marketing.Email.Dialog.EditCampaign.Field.Subject.Hint')"
                            :label="$t('Marketing.Email.Dialog.EditCampaign.Field.Subject.Label')"
                            :prepend-icon="$t('Marketing.Email.Dialog.EditCampaign.Field.Subject.Icon')"
                            :rules="formFieldRules.Subject"
                            filled
                            hide-details="auto"
                          />
                        </v-col>

                        <v-col
                          v-if="isVisible"
                          cols="12"
                        >
                          <unlayer-editor
                            ref="editor"
                            :appearance="editor.appearance"
                            :editor-id="editor.id"
                            :min-height="editor.minHeight"
                            :options="editor.options"
                            :project-id="editor.projectId"
                            :tools="editor.tools"
                            @load="editorLoaded"
                            @ready="editorReady"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-card-title>{{ $t('Marketing.Email.Dialog.EditCampaign.Section.Delivery') }}</v-card-title>
                  <v-card-text>
                    <v-container
                      class="pa-0"
                      fluid
                    >
                      <v-row dense>
                        <v-col cols="12">
                          <v-radio-group
                            v-model="deliveryType"
                            hide-details
                          >
                            <v-radio
                              key="now"
                              :label="$t('Marketing.Email.Dialog.EditCampaign.Field.ScheduledAt.LabelNow')"
                              value="now"
                            />

                            <v-radio
                              key="scheduled"
                              :label="$t('Marketing.Email.Dialog.EditCampaign.Field.ScheduledAt.LabelScheduled')"
                              value="scheduled"
                            />
                          </v-radio-group>
                        </v-col>

                        <template v-if="deliveryType === 'scheduled'">
                          <v-col
                            cols="12"
                            md="3"
                          >
                            <v-menu
                              v-model="scheduledAtDateVisible"
                              :close-on-content-click="false"
                              max-width="290px"
                              min-width="290px"
                              offset-y
                              transition="scale-transition"
                            >
                              <template #activator="{on}">
                                <v-text-field
                                  v-model="scheduledAt.DateFrm"
                                  :label="$t('Common.Date.Title')"
                                  :rules="formFieldRules.ScheduledAtDate"
                                  prepend-icon="event"
                                  readonly
                                  @blur="scheduledAt.Date = parseDate(scheduledAt.DateFrm)"
                                  v-on="on"
                                />
                              </template>

                              <v-date-picker
                                v-model="scheduledAt.Date"
                                :locale="$i18n.languages.find(lang => lang.locale === $i18n.locale).code || 'el-GR'"
                                first-day-of-week="1"
                                scrollable
                                @input="($event) => {
                                  scheduledAt.DateFrm = formatDate($event)
                                  scheduledAtDateVisible = false
                                }"
                              />
                            </v-menu>
                          </v-col>

                          <v-col
                            cols="12"
                            md="3"
                          >
                            <v-menu
                              v-model="scheduledAtTimeVisible"
                              :close-on-content-click="false"
                              offset-y
                              transition="scale-transition"
                            >
                              <template #activator="{on}">
                                <v-text-field
                                  v-model="scheduledAt.Time"
                                  :label="$t('Common.Date.Time')"
                                  :rules="formFieldRules.ScheduledAtTime"
                                  prepend-icon="access_time"
                                  readonly
                                  v-on="on"
                                />
                              </template>

                              <v-time-picker
                                v-model="scheduledAt.Time"
                                :locale="$i18n.languages.find(lang => lang.locale === $i18n.locale).code || 'el-GR'"
                                first-day-of-week="1"
                                format="24hr"
                                scrollable
                                @input="() => {scheduledAtTimeVisible = false}"
                              />
                            </v-menu>
                          </v-col>
                        </template>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-2">
        <v-spacer />

        <v-btn
          class="light-blue--text text--darken-1"
          outlined
          @click="onCancelButtonClick"
        >
          {{ $t('Common.Button.Close').toLocaleUpperCase($i18n.locale) }}
        </v-btn>

        <v-btn
          :disabled="formIsSaving || !editorIsReady"
          :loading="formIsSaving"
          color="blue"
          dark
          depressed
          @click="onSaveButtonClick"
        >
          {{ $t('Common.Button.Save').toLocaleUpperCase($i18n.locale) }}
        </v-btn>

        <v-btn
          :disabled="formIsSaving || !editorIsReady"
          :loading="formIsSaving"
          color="green"
          dark
          depressed
          @click="onSendButtonClick"
        >
          {{ $t('Common.Button.Send').toLocaleUpperCase($i18n.locale) }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <tag-add-dialog :visible.sync="tagAddDialogVisible" />

    <confirm-dialog
      :html-content="$t('Marketing.Email.Dialog.EditCampaign.ConfirmSend.Content')"
      :html-title="$t('Marketing.Email.Dialog.EditCampaign.ConfirmSend.Title')"
      :visible.sync="sendConfirmDialogVisible"
      :width="560"
      no-button-class="v-btn--outline green--text"
      title-class="red white--text lighten-0"
      yes-button-class="red white--text"
      yes-button-event="on-confirm-delete"
      @on-confirm-delete="onSendConfirm"
    />
  </v-dialog>
</template>

<script>
import Auth from '@/mixins/auth'
import DialogVisible from '@/mixins/dialogVisible'
import UnlayerEditor from '@/components/common/unlayer-editor/UnlayerEditor.vue'
import {clone, mergeDeep} from '@/lib/helper/helper.js'
import TagAddDialog from '@/components/marketing/tag/TagAddDialog.vue'
import ConfirmDialog from '@/components/common/ConfirmDialog.vue'

export default {
  name      : 'EmailCampaignEditDialog',
  components: {ConfirmDialog, TagAddDialog, UnlayerEditor},
  mixins    : [Auth, DialogVisible],
  props     : {
    template: {
      type   : Object,
      default: undefined
    },

    groups: {
      type   : Array,
      default: () => []
    }
  },
  data() {
    return {
      tags                    : [],
      tagAddDialogVisible     : false,
      isFullScreen            : true,
      dataFormValid           : false,
      editItem                : null,
      deliveryType            : 'now',
      scheduledAtDateVisible  : false,
      scheduledAtTimeVisible  : false,
      sendConfirmDialogVisible: false,
      scheduledAt             : {
        Date   : '',
        DateFrm: '',
        Time   : ''
      },
      defaultDataObj: {
        Id           : null,
        Type         : 'email',
        Name         : '',
        Title        : '',
        Draft        : true,
        Tag          : [],
        GroupIncludes: [],
        GroupExcludes: [],
        SenderName   : '',
        SenderEmail  : '',
        Subject      : '',
        Body         : '',
        BodyText     : '',
        Source       : '',
        ScheduledAt  : '',
        Image        : '',
        ImageExt     : '',
        ImageBase64  : ''
      },
      editorIsReady: false,
      editor       : {
        id       : 'email-campaign-editor-id',
        //projectId: 0,
        locale   : 'en-US',
        minHeight: '745px',
        tools    : {},
        options  : {
          version    : 'stable', // Specify 'latest', 'stable' or a specific version number
          displayMode: 'email', // email, web, popup
          features   : {
            textEditor: {
              tables: true, // Enable tables in the text editor
              emojis: true // Enable emoji support in the text editor
            }
          },
          mergeTags: {
            customer: {
              name     : 'Customer',
              mergeTags: {
                first_name: {
                  name  : 'First Name',
                  value : '{{first_name}}',
                  sample: 'John'
                },
                last_name: {
                  name  : 'Last Name',
                  value : '{{last_name}}',
                  sample: 'Doe'
                },
                email: {
                  name  : 'Email',
                  value : '{{email}}',
                  sample: 'test@test.com'
                }
              }
            }
          }
        }
      },
      formIsSaving  : false,
      formFieldRules: {
        Name: [
          (v) => !!v || this.$t('Marketing.Email.Dialog.EditCampaign.Field.Name.Error.Required'),
          (v) => v && v.length >= 2 && v.length <= 255 || this.$t('Marketing.Email.Dialog.EditCampaign.Field.Name.Error.Between')
        ],
        Subject: [
          (v) => !!v || this.$t('Marketing.Email.Dialog.EditCampaign.Field.Subject.Error.Required'),
          (v) => v && v.length >= 2 && v.length <= 255 || this.$t('Marketing.Email.Dialog.EditCampaign.Field.Subject.Error.Between')
        ],
        ScheduledAtDate: [
          (v) => !!v && this.deliveryType === 'scheduled' || this.$t('Marketing.Email.Dialog.EditCampaign.Field.ScheduledAt.Error.RequiredDate')
        ],
        ScheduledAtTime: [
          (v) => !!v && this.deliveryType === 'scheduled' || this.$t('Marketing.Email.Dialog.EditCampaign.Field.ScheduledAt.Error.RequiredTime')
        ]
      }
    }
  },
  computed: {
    tagItems() {
      return this.tags.filter(tag => !tag.IsDeleted)
    }
  },
  watch: {
    deliveryType(newVal) {
      if (newVal === 'now') {
        this.editItem.ScheduledAt = ''
      }
    },

    scheduledAt: {
      deep: true,
      handler(newVal) {
        if (newVal.Date && newVal.Time) {
          this.editItem.ScheduledAt = `${newVal.Date} ${newVal.Time}:00`
        }
      }
    },

    isVisible(newVal) {
      if (newVal) {
        this.initDialog()
      } else {
        this.destroyDialog()
      }
    }
  },
  created() {
    this.initDialog()
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
    this.destroyDialog()
  },
  methods: {
    initDialog() {
      this.tags = []
      this.editItem = clone(mergeDeep(this.defaultDataObj, this.template || {}))

      if (this.editItem.ScheduledAt) {
        const [d, t] = this.editItem.ScheduledAt.split(' ')
        this.scheduledAt = {
          Date   : this.parseDate(d, '/'),
          DateFrm: this.formatDate(this.parseDate(d, '/')),
          Time   : t.substring(0, t.length - 3)
        }

        this.deliveryType = 'scheduled'
      } else {
        this.scheduledAt = {
          Date   : '',
          DateFrm: '',
          Time   : ''
        }
        this.deliveryType = 'now'
      }
      this.editorIsReady = false
      this.initEvents()
      this.getTags()
    },
    destroyDialog() {
      this.tags = []
      this.editItem = null
      this.editorIsReady = false
      this.destroyEvents()
    },
    initEvents() {
      this.destroyEvents()
      this.$bus.$on(window.SocketCommand.Marketing.Email.Save, this.onSaveResult)
      this.$bus.$on(window.SocketCommand.Marketing.Email.Send, this.onSendResult)
      this.$bus.$on(window.SocketCommand.Marketing.Tag.Save, this.getTags)
      this.$bus.$on(window.SocketCommand.Marketing.Tag.Combo, this.onTagsResult)
    },
    destroyEvents() {
      this.$bus.$off(window.SocketCommand.Marketing.Email.Save, this.onSaveResult)
      this.$bus.$off(window.SocketCommand.Marketing.Email.Send, this.onSendResult)
      this.$bus.$off(window.SocketCommand.Marketing.Tag.Save, this.getTags)
      this.$bus.$off(window.SocketCommand.Marketing.Tag.Combo, this.onTagsResult)
    },

    getTags() {
      window.callAS(window.SocketCommand.Marketing.Tag.Combo)
    },

    editorReady() {
      this.editorIsReady = true
    },

    editorLoaded() {
      if (this.editItem?.Source) {
        this.$refs.editor.editor.loadDesign(this.editItem.Source)
      }
    },

    onSaveButtonClick() {
      if (!this.$refs.dataForm.validate()) return

      this.formIsSaving = true
      const payload = clone(this.editItem)
      payload.Draft = true

      this.$refs.editor.editor.exportHtml(
        (data) => {
          payload.Source = data?.design || null
          payload.Body = this.htmlDecode(data?.html || '')

          this.$refs.editor.editor.exportPlainText(
            (data) => {
              payload.BodyText = data?.text || ''

              window.callAS(window.SocketCommand.Marketing.Email.Save, payload)
            }
          )
        }
      )
    },

    onSaveResult(data) {
      this.formIsSaving = false

      if (data && data.status === 'success') {
        if (data?.Id) this.editItem.Id = data.Id
        this.$bus.$emit('app-show-notification', {
          body: this.$t('Marketing.Email.Dialog.EditCampaign.Message.Save.Success'),
          type: 'success',
          icon: 'info'
        })
      } else {
        this.showGenericError()
      }
    },

    onSendButtonClick() {
      if (!this.$refs.dataForm.validate()) return
      this.sendConfirmDialogVisible = true
    },

    onSendConfirm() {
      this.formIsSaving = true
      const payload = clone(this.editItem)
      payload.Draft = false

      this.$refs.editor.editor.exportHtml(
        (data) => {
          payload.Source = data?.design || null
          payload.Body = this.htmlDecode(data?.html || '')

          this.$refs.editor.editor.exportPlainText(
            (data) => {
              payload.BodyText = data?.text || ''

              window.callAS(window.SocketCommand.Marketing.Email.Save, payload, window.SocketCommand.Marketing.Email.Send)
            }
          )
        }
      )
    },

    onSendResult(data) {
      this.formIsSaving = false

      if (data && data.status === 'success') {
        this.$bus.$emit('app-show-notification', {
          body: this.$t('Marketing.Email.Dialog.EditCampaign.Message.Send.Success'),
          type: 'success',
          icon: 'info'
        })
        this.onCancelButtonClick()
      } else {
        this.showGenericError()
      }
    },

    onTagsResult: function (data) {
      if (Array.isArray(data)) {
        this.tags = data || []

        this.editItem.Tag = this.editItem.Tag.filter(tagId => data.some(t => tagId === t.Id && !t.IsDeleted))
      }
    },

    showAddTagDialog() {
      this.tagAddDialogVisible = true
    },

    showGenericError() {
      this.$bus.$emit('app-show-notification', {
        body: this.$t('Common.Error.Generic'),
        type: 'error',
        icon: 'warning'
      })
    },

    formatDate(date, separator = '-') {
      if (!date) {
        return null
      }

      const [year, month, day] = date.split(separator)
      return `${day}-${month}-${year}`
    },

    parseDate(date, separator = '-') {
      if (!date) {
        return null
      }

      const [day, month, year] = date.split(separator)
      return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`
    },

    htmlDecode(input) {
      const doc = new DOMParser().parseFromString(input, 'text/html')
      return doc.documentElement.innerHTML
    },

    onCancelButtonClick() {
      this.closeDialog()
    }
  }
}
</script>
